// List of fancy fonts for signatures
export const SIGNATURE_FONTS = [
    { name: 'Dancing Script', value: 'Dancing Script, cursive', url: 'https://fonts.googleapis.com/css2?family=Dancing+Script&display=swap' },
    { name: 'Pacifico', value: 'Pacifico, cursive', url: 'https://fonts.googleapis.com/css2?family=Pacifico&display=swap' },
    { name: 'Great Vibes', value: 'Great Vibes, cursive', url: 'https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap' },
    { name: 'Sacramento', value: 'Sacramento, cursive', url: 'https://fonts.googleapis.com/css2?family=Sacramento&display=swap' },
    { name: 'Tangerine', value: 'Tangerine, cursive', url: 'https://fonts.googleapis.com/css2?family=Tangerine&display=swap' },
    { name: 'Alex Brush', value: 'Alex Brush, cursive', url: 'https://fonts.googleapis.com/css2?family=Alex+Brush&display=swap' },
    { name: 'Pinyon Script', value: 'Pinyon Script, cursive', url: 'https://fonts.googleapis.com/css2?family=Pinyon+Script&display=swap' },
    { name: 'Mr De Haviland', value: 'Mr De Haviland, cursive', url: 'https://fonts.googleapis.com/css2?family=Mr+De+Haviland&display=swap' },
];

// Signature color options
export const SIGNATURE_COLORS = [
    { name: 'Black', value: '#000000' },
    { name: 'Blue', value: '#0000FF' },
    { name: 'Navy Blue', value: '#000080' },
    { name: 'Dark Blue', value: '#00008B' },
    { name: 'Red', value: '#FF0000' },
    { name: 'Green', value: '#008000' },
];